'use client';
var classes = {"root":"m_89d60db1","list--default":"m_576c9d4","list":"m_89d33d6d","tab":"m_4ec4dce6","panel":"m_b0c91715","tabSection":"m_fc420b1f","tabLabel":"m_42bbd1ae","tab--default":"m_539e827b","list--outline":"m_6772fbd5","tab--outline":"m_b59ab47c","tab--pills":"m_c3381914"};

export { classes as default };
//# sourceMappingURL=Tabs.module.css.mjs.map
